import React from 'react'
import { DeleteDivision, UpdateDivison } from './AddDivision';

const Division = ({ division, getdivision, buffer }) => {


    return (
        <>

            <div className='table-box scroll-container-table'
                style={{ height: "80vh" }}
            >

                <table className="table-css width-100vw">
                    <thead className="table-heading">
                        <tr className="custom-table-head-tr ">
                            <th className="table-heading-text text-left-sr">S.No.</th>
                            <th className="table-heading-text text-start">Sub Company Name</th>
                            <th className="table-heading-text text-start">Mobile Number</th>
                            <th className="table-heading-text text-start">GST Number</th>
                            <th className="table-heading-text text-start">Address</th>
                            <th className="table-heading-text text-start" style={{ justifyContent: 'right', paddingRight: '40px' }}>Action </th>


                        </tr>
                    </thead>
                    {buffer ? (
                        <div className="spinner-bgdatil"></div>

                    ) : (

                        <tbody style={{ height: "70vh" }}>
                            {division?.map((i, index) => (
                                <React.Fragment key={index}>
                                    <tr className="custom-table-head-td" >
                                        <td className="table-body text-left-sr">{index + 1}.</td>
                                        <td className="table-body text-start">{i.division_name}</td>
                                        <td className="table-body text-start">{i.mobile_name}</td>
                                        <td className="table-body text-start">{i.gst_number}</td>
                                        <td className="table-body text-start">{i.address}</td>



                                        <td className="table-body text-start" style={{ justifyContent: 'right' }}>
                                            <div className="flex-row justify-start ">

                                                <UpdateDivison i={i} getdivision={getdivision} />
                                                <DeleteDivision i={i} getdivision={getdivision} />




                                            </div>
                                        </td>





                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>

                    )}
                </table>


            </div>

        </>
    );
}

export default Division
